/** Chat widget supported message types. */
export enum MessageType {
  TEXT = "text",
  IMAGE = "image",
  CARD = "card",
  CAROUSEL = "carousel",
  END = "END",
}

/** Default delay in milliseconds */
export const DEFAULT_MESSAGE_DELAY = 1000;
